import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {Student} from '../../model/student';
import {AppSettings} from '../../../app-settings';
import {ActivatedRoute} from '@angular/router';
import {DataManagementService} from '../../services/data-management.service';
import {AuthenticationService} from '../../services/authentication.service';
import {Constants} from '../../constants';
import {RoundNameConstants} from '../../round-name-constants';

@Component({
    selector: 'app-round-one-reports',
    templateUrl: './round-one-reports.component.html',
    styleUrls: ['./round-one-reports.component.css']
})
export class RoundOneReportsComponent implements OnInit {
    dtTrigger: Subject<string> = new Subject();
    dtOptions: DataTables.Settings = {};
    filter_id;
    title;
    token;
    students: Student[];
    rounds = [];
    outgoingRoundId = '0';
    downloadPracticeRoundBiddingResultsExcel = AppSettings.DOWNLOAD_ROUND_WISE_BIDDING_RESULTS;
    downloadPracticeRoundProcessingResultsExcel = AppSettings.DOWNLOAD_ROUND_WISE_PROCESSING_OUTPUT;
    downloadRoundPreferencesExcel = AppSettings.DOWNLOAD_UNIVERSITY_PREFERENCES;
    downloadRoundAllotmentReport = AppSettings.DOWNLOAD_OUTGOING_ALLOTMENT_REPORT;
    selectUndefinedOptionValue = '0';
    roundPreferences = [];
    roundUniversityWiseAllotment = [];
    processingOutput = [];
    biddingResults = [];
    errorMessage;
    rowGroupMetadata: any;

    constructor(private route: ActivatedRoute,
                private dmService: DataManagementService,
                private authenticationService: AuthenticationService) {
    }

    getAllRounds(): void {
        this.dmService.getAll(Constants.ROUND_SETTINGS)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        // this.rounds = response.data;
                        for (let i = 0; i < response.data.length; i++) {
                            if (response.data[i].outgoing_round_name_id === parseInt(RoundNameConstants.BIDDING_ROUND_ONE, 10)) {
                                if (this.filter_id === 1 || this.filter_id === 2 || this.filter_id === 3 || this.filter_id === 4) {
                                    this.rounds.push(response.data[i]);
                                }
                            }
                            if (response.data[i].outgoing_round_name_id === parseInt(RoundNameConstants.BIDDING_ROUND_TWO, 10)) {
                                if (this.filter_id === 5 || this.filter_id === 6 || this.filter_id === 7 || this.filter_id === 8) {
                                    this.rounds.push(response.data[i]);
                                }
                            }
                            if (response.data[i].outgoing_round_name_id === parseInt(RoundNameConstants.BIDDING_ROUND_THREE, 10)) {
                                if (this.filter_id === 9 || this.filter_id === 10 || this.filter_id === 11 || this.filter_id === 12) {
                                    this.rounds.push(response.data[i]);
                                }
                            }
                        }
                        if (this.rounds.length > 0) {
                            this.outgoingRoundId = this.rounds[0].outgoing_round_id;
                        }
                        if (this.filter_id === 1 || this.filter_id ===  5 || this.filter_id === 9) {
                            this.getUniversityPreferences();
                        } else if (this.filter_id === 2 || this.filter_id ===  6 || this.filter_id === 10) {
                            this.getProcessingReport();
                        } else if (this.filter_id === 3 || this.filter_id ===  7 || this.filter_id === 11) {
                            this.getBiddingResponse();
                        } else if (this.filter_id === 4 || this.filter_id ===  8 || this.filter_id === 12) {
                            this.getUniversityAllotment();
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getBiddingResponse(): void {
        this.dmService.getOne(Constants.BIDDING_RESPONSE_REPORT, this.outgoingRoundId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.biddingResults = response.data;
                        if (this.biddingResults.length <= 0) {
                            this.errorMessage = 'There is no data available for Bidding Result.';
                        } else {
                            this.dtTrigger.next();
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getProcessingReport(): void {
        this.dmService.getOne(Constants.PROCESSING_OUTPUT_REPORT, this.outgoingRoundId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.processingOutput = response.data;
                        if (this.processingOutput.length <= 0) {
                            this.errorMessage = 'There is no data available for Bidding Processing.';
                        } else {
                            this.dtTrigger.next();
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getUniversityPreferences(): void {
        this.dmService.getOne(Constants.UNIVERSITY_PREFERENCES, this.outgoingRoundId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.roundPreferences = response.data;
                        if (this.roundPreferences.length === 0) {
                            this.errorMessage = 'There is no data available for round preferences.';
                        } else {
                            this.dtTrigger.next();
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getUniversityAllotment(): void {
        this.dmService.getOne(Constants.UNIVERSITY_WISE_ALLOTMENT, this.outgoingRoundId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.roundUniversityWiseAllotment = response.data;
                        if (this.roundUniversityWiseAllotment.length === 0) {
                            this.errorMessage = 'There is no data available for university wise allotment.';
                        } else {
                            this.updateRowGroupMetaData();
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    termChange() {
        if (this.filter_id === 1 || this.filter_id ===  5 || this.filter_id === 9) {
            this.getUniversityPreferences();
        } else if (this.filter_id === 2 || this.filter_id ===  6 || this.filter_id === 10) {
            this.getProcessingReport();
        } else if (this.filter_id === 3 || this.filter_id ===  7 || this.filter_id === 11) {
            this.getBiddingResponse();
        } else if (this.filter_id === 4 || this.filter_id ===  8 || this.filter_id === 12) {
            this.getUniversityAllotment();
        }
    }

    updateRowGroupMetaData() {
        this.rowGroupMetadata = {};
        if (this.roundUniversityWiseAllotment) {
            for (let i = 0; i < this.roundUniversityWiseAllotment.length; i++) {
                const rowData = this.roundUniversityWiseAllotment[i];
                const universityNameWithSeats = rowData.university_name_with_seats;
                if (i === 0) {
                    this.rowGroupMetadata[universityNameWithSeats] = {index: 0, size: 1};
                } else {
                    const previousRowData = this.roundUniversityWiseAllotment[i - 1];
                    const previousRowGroup = previousRowData.university_name_with_seats;
                    if (universityNameWithSeats === previousRowGroup) {
                        this.rowGroupMetadata[universityNameWithSeats].size++;
                    } else {
                        this.rowGroupMetadata[universityNameWithSeats] = {index: i, size: 1};
                    }
                }
            }
        }
    }

    ngOnInit() {
        this.getAllRounds();
        this.token = '?token=' + this.authenticationService.getToken();
        this.route
            .params
            .subscribe(params => {
                this.filter_id = parseInt(params['id'], 10);
            });
        if (this.filter_id === 1) {
            this.title = 'Round I Student University Preferences';
        } else if (this.filter_id === 2) {
            this.title = 'Round I Bidding Processing Report';
        } else if (this.filter_id === 3) {
            this.title = 'Round I Bidding Result Report';
        } else if (this.filter_id === 4) {
            this.title = 'Round I University-wise Allotment Report';
        }
        if (this.filter_id === 5) {
            this.title = 'Round II Student University Preferences';
        } else if (this.filter_id === 6) {
            this.title = 'Round II Bidding Processing Report';
        } else if (this.filter_id === 7) {
            this.title = 'Round II Bidding Result Report';
        } else if (this.filter_id === 8) {
            this.title = 'Round II University-wise Allotment Report';
        }
        if (this.filter_id === 9) {
            this.title = 'Round III Student University Preferences';
        } else if (this.filter_id === 10) {
            this.title = 'Round III Bidding Processing Report';
        } else if (this.filter_id === 11) {
            this.title = 'Round III Bidding Result Report';
        } else if (this.filter_id === 12) {
            this.title = 'Round III University-wise Allotment Report';
        }
        this.dtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false
        };
    }

}
